/**
 * Why a member deleted their account: the choices on the last screen before deleting
 * (apps/web Account → Delete account), stored anonymously in `deletion_feedback`. The web app
 * words them in the member's language; the admin shows them in English (apps/admin Overview).
 * Add new ones at the end; never rename a key (stored answers keep it).
 */
export const LEAVING_REASONS = [
  'earning_slow',
  'missing_coins',
  'cashout_hard',
  'few_offers',
  'surveys_screen_out',
  'privacy',
  'other_account',
  'not_using',
  'other',
] as const;
export type LeavingReason = (typeof LEAVING_REASONS)[number];

/** The longest note kept with the answer. */
export const LEAVING_NOTE_MAX = 500;
